import { connect } from 'react-redux';
import TaskEntityCard from '../components/TaskEntityCard';

export default connect(state => ({ task: state.selectedRejectedTask }))(TaskEntityCard);
